import _ from 'lodash';
import environment from '../environment';

const LayerControls = (name) => require('../controls').get(name);

export const isBelowState = (id) => {
    const dataSource = _.assign({}, environment.get('CONFIG.FILTERS.AREAS_TYPES'), environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES'));
    return _(dataSource)
        .filter((t) => _.some(['Bairro', 'Distrito', 'Subdistrito', 'Setor Censitário', 'PMA'], a => t.name === a))
        .some((t) => String(t.id) === String(id));
};

export const isNationalArea = (value, text) => {
    return value === -1 || _.some(environment.get('CONFIG.FILTERS.AREAS_TYPES'), v => v.name === text);
};

export const isClient = name => environment.get('CONFIG.DEALERS').contains(name);

export const isLayerEnabled = name => {
    const check = () => {
        try {
            return LayerControls(name).check();
        } catch (err) {
            return false;
        }
    };

    return check();
};

export const hasImage = image =>
    new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = `${environment.get('IMAGES_HOST')}/${image}.png`;
    });



// WEBPACK FOOTER //
// ./src/scripts/shared/validation.js